module.exports = __webpack_public_path__ + "static/media/16.Dona Pattal Making Machine.95dc9d9f.jpg";